module.exports = __webpack_public_path__ + "58e680fa2d1f0642897b78f4692284c1.png";